import { HttpErrorResponse } from '@angular/common/http';
import { SessionBaseComponent } from './../../../../../../shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DropdownOptionsService } from '../../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Injector } from '@angular/core';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';

@Component({
  selector: 'laas-rtn-delivery-remark',
  templateUrl: './rtn-delivery-remark.component.html',
  styleUrls: ['./rtn-delivery-remark.component.scss']
})
export class RtnDeliveryRemarkComponent extends SessionBaseComponent implements OnInit, OnChanges {

  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() rtnDeliveryRemarkSaved: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;
  readonly preferenceKey: string;
  isVisible: boolean;
  columns: any[];
  selectedCols: any[];
  selectedRows: any[];
  DOStatusOptions: any[];
  timezone: string;
  form: FormGroup;
  submitted: boolean;

  constructor(
    injector: Injector,
    private dropdownOptionService: DropdownOptionsService,
    private logisticsService: LogisticsService,
    private fb: FormBuilder) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.RtnDeliveryRemark;
    this.timezone = this.laasSetting.facilityTimeZone;
    this.isVisible = false;
    this.booking = null;
    this.columns = [
      { field: 'rtnDeliveryRemark', header: '重送原因' },
      { field: 'rtnDeliveryCnt', header: '重送次數'},
      { field: 'facility', header: '倉別' },
      { field: 'doNo', header: this.translateService.instant('DeliveryOrder.DoNo') },
      { field: 'invoiceNo', header: 'DO_INVOICE No.' },
      { field: 'consigneeKey', header: '客戶代碼' },
      { field: 'consigneeCompany', header: '客戶名稱' },
      { field: 'shipNotes', header: '備註' },
      { field: 'rushCar', header: '急車' },
      { field: 'cartonCnt', header: '箱數' },
      { field: 'totalGrossWeight', header: '毛重' },
      { field: 'totalNetWeight', header: '淨重' },
      { field: 'volumeWeight', header: '材積' },
      { field: 'doStatus', header: 'DO處理狀態' },
      { field: 'orgName', header: '下單公司' },
      { field: 'shipCorpName', header: '出貨公司' },
      { field: 'letterHeadOrgName', header: 'Letter Head公司' },
      { field: 'csr', header: 'CSR' },
      { field: 'dept', header: '部門' },
      { field: 'bookingCount', header: 'Booking次數' },
      { field: 'cancelDescr', header: '取消原因(多次派車原因)' },
      { field: 'loadingDate', header: '上車時間', dataType: 'date' },
      { field: 'loadingWho', header: '上車人員工號' },
      { field: 'leaveWhsDate', header: '出倉時間', dataType: 'date' },
      { field: 'leaveWhsWho', header: '出倉人員工號' },
      { field: 'eta', header: '到貨時間', dataType: 'date' },
      { field: 'arriveWho', header: '到貨人員工號' },
      { field: 'tmsUrl', header: 'TMS_URL' },
      { field: 'eArrivalDate', header: '預估到貨時間', dataType: 'date' },
      { field: 'createUser', header: '建立人員' },
      { field: 'createDt', header: '建立時間', dataType: 'date' },
      { field: 'updateUser', header: '更新人員' },
      { field: 'updateDt', header: '更新時間', dataType: 'date' }
    ];
    this.selectedCols = this.columns;
    this.selectedRows = [];
    this.DOStatusOptions = [];
    this.form = this.fb.group({
      details: this.fb.array([])
    });
    this.submitted = false;
    this.visibleChange = new EventEmitter<any>();
    this.rtnDeliveryRemarkSaved = new EventEmitter<any>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.logger.info(changes);
    if (isNullOrEmpty(changes.booking?.currentValue) === false) {
      const details = changes.booking?.currentValue?.bookingDetails ?? [];
      this.form.controls.details = this.fb.array([]);
      for (const detail of details) {
        const group = this.fb.group({
          rtnDeliveryRemark: [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
          rtnDeliveryCnt: [null, Validators.compose([Validators.required, Validators.max(9)])]
        });
        ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).push(group);
        this.setRtnDeliveryRemarkValidator(group.get('rtnDeliveryRemark'), false);
        this.setRtnDeliveryCntValidator(group.get('rtnDeliveryCnt'),false);

        detail.remarkVal = '';
        detail.returnVal = 0;
      }
    }
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.dropdownOptionService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  confirmBtnClick(event: any): void {
    if (this.selectedRows.length === 0) {
      this.dialog.close(event);
      return;
    }

    if (this.form.controls.details.invalid) {
      this.submitted = true;
      this.toastService.warn('請檢查是否有必填欄位尚未填寫');
      return;
    }

    this.submitted = false;
    const reasons = this.selectedRows.map(x => ({ doNo: x.doNo, reason: x.remarkVal, redeliveryCount : x.returnVal }));
    this.logisticsService.markReturnDelivery(this.booking.bookingNo, reasons)
      .subscribe({
        next: result => {
          this.dialog.close(event);
          this.rtnDeliveryRemarkSaved.emit({ originalEvent: event });
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  rowSelected(event: any): void {
    const ctrl = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[event.index]?.get('rtnDeliveryRemark');
    const ctrlcnt = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[event.index]?.get('rtnDeliveryCnt');
    this.setRtnDeliveryRemarkValidator(ctrl, true);
    this.setRtnDeliveryCntValidator(ctrlcnt, true);
  }

  rowUnSelected(event: any): void {
    const ctrl = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[event.index]?.get('rtnDeliveryRemark');
    const ctrlcnt = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[event.index]?.get('rtnDeliveryCnt');
    this.setRtnDeliveryRemarkValidator(ctrl, false);
    this.setRtnDeliveryCntValidator(ctrlcnt, false);
  }

  allRowSelected(event: any, bookingDetailLength: any): void {
    for (var i = 0; i < bookingDetailLength; i++) {
      const ctrl = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[i]?.get('rtnDeliveryRemark');
      const ctrlcnt = ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[i]?.get('rtnDeliveryCnt');
      this.setRtnDeliveryRemarkValidator(ctrl, event.checked);
      this.setRtnDeliveryCntValidator(ctrlcnt, event.checked);
    }
  }

  getFormGroup(idx: number): FormGroup {
    return ValidationFuncs.castFormControlAsFormArray(this.form.controls.details).controls[idx] as FormGroup;
  }

  isShowValidationMessage(control: AbstractControl | null, submitted: boolean): boolean {
    if (isNullOrEmpty(control)) {
      return false;
    }
    const ctrl = control as AbstractControl;

    return ctrl.invalid && (submitted || ctrl.touched);
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter(x => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  private setRtnDeliveryRemarkValidator(control: AbstractControl | null, enable: boolean): void {
    if (isNullOrEmpty(control)) {
      return;
    }

    const ctrl = control as AbstractControl;
    if (enable) {
      ctrl.setValidators(Validators.compose([Validators.required, Validators.maxLength(200)]));
      ctrl.updateValueAndValidity();
    } else {
      ctrl.setErrors(null);
      ctrl.clearValidators();
      ctrl.updateValueAndValidity();
    }
  }

  private setRtnDeliveryCntValidator(control: AbstractControl | null, enable: boolean): void {
    if (isNullOrEmpty(control)) {
      return;
    }

    const ctrl = control as AbstractControl;
    if (enable) {
      ctrl.setValidators(Validators.compose([Validators.required, Validators.max(9)]));
      ctrl.updateValueAndValidity();
    } else {
      ctrl.setErrors(null);
      ctrl.clearValidators();
      ctrl.updateValueAndValidity();
    }
  }
}
